function shwmodal() {

    if ( !! $('#shm-modal').length ) {

        if( readCookie('ushm') != 1) {

            $('#shm-modal').fadeIn(300);

            $('#shm-modal .md-close').on('click', function(){
                $('#shm-modal').fadeOut(300);
                setTimeout(function(){
                    createCookie('ushm', 1, 1);
                    $('#shm-modal').remove();
                }, 1000);
            });

            document.getElementById('dotsvid').addEventListener('ended', function(e) {

                setTimeout(function(){
                    $('#shm-modal .md-close').trigger('click');
                }, 300);

            });


        }

    }
}

function globalLiveStream() {

    // WorldWide Global DropDown
    $.get( ultra_settings.endpoints.livestream_url , function() {})
    .done(function(data) {


        if(data[0].dark_background == true){

            log(readCookie('showvid'));
            if(readCookie('showvid') != 1) {
                $('.globalvid').trigger('click');
                createCookie('showvid', 1, .04);
            }
            log(readCookie('showvid'));

        }

    });


    // if home page and no force hide livestream
    if ( !! $('body.page-template-page-home-migrate-php').length && ! $('#fls').length ) {

        // WorldWide Global DropDown
        $.get( ultra_settings.endpoints.livestream_url , function() {})
        .done(function(data) {

            var ls = data[0];
            var bg = '';
            var sitetitle = '';

          // If not enabled or no video
          if( !ls.enable_livestream || !ls.live_stream) {
              return;
          };

          if(ls.dark_background) {
              bg = '<div class="background-overlay"> <div class="bg-darken bg"></div> <div class="bg-texture bg"></div> <div class="desk-hide"> <div class="bg-darken bg"></div> <div class="bg-darken bg"></div> </div> <div class="bg loader" style="display: none;"> <div class="spinner"> <div class="u"></div> </div> </div></div>';
          }

          if(sitename) {
              sitetitle = 'to '+ sitename;
          }

          var lshtml = `<div class="overbox overboxww overboxls" style="display:none;">
          <div class="inner">
          <div class=" rs100 text-center">
          <div id="ls-header" class="clearfix w980" style="width:330px; top:20px; position: relative; left:45px">
          <a target="ultralive" href="javascript: open_window(${ls.ultra_live},1024,720);" id="ls-umftv" class="vid-switcher pointer rel">
          <span><strong>UMF TV</strong> <em class="red" style="color:#d71d33; font-style:normal;">Presents:</em></span> <img src="https://ultramusicfestival.com/wp-content/uploads/2016/03/umf-tv-logo.png" width="190" style="padding-bottom:10px"> <b class="red-left ra1"></b> <b class="red-right ra2"   style="top:100px;"></b> <b class="ba1" style="top:110px;"></b> <b class="ba2"></b> </a> <a href="${ls.event_url}" target="_blank" class="ulogo" style="display:block; text-align: center; margin:auto; width:120px; position: relative; left:90px; top:20px"> <img width="200" height="71" src="${ls.event_logo}"  style="display: inline-block;"> </a>
          </div>
          <div class="lbreak op50"></div>
          <a class="btn-main btn-continue nojax outline-btn btn-lg" style="">Continue ${sitetitle}
          <span class="fas fa-chevron-right"></span></a> </div>
          <div class="stream-vid">
          <div class="vid-wrap">
          <iframe width="1280" height="720" src="${ls.live_stream}" frameborder="0" allowfullscreen></iframe>
          </div>
          </div>
          </div>
          <div class="overlayww bg bg-cover2" style="background-image: url(${ls.background_image}); background-position:center center">${bg}</div>
          </div>`;

          $('#footer').after(lshtml);
          $('.overbox').fadeIn(300);

      });

        $(document).on('click', '.overbox .close', function(){
            $('.overbox').fadeOut(300);
        });
        $(document).on('click','.overbox .btn-continue', function(){
            $('.overbox').fadeOut(300);
            setTimeout(function() { $('.overbox').remove(); }, 1000)
        });


        // if live stream homepage open all links new window
        if( !! $("body.page-template-page-livestream").length) {
            $('#footer a, #header li:not(.menu-item-language) a, #header .feature-button, #ww a, .fsignup form').attr('target', '_blank');
        }

    }


    if( !! $(".vid-switcher").length) {

      //$(".vid-switcher:not(.active)").fadeTo(300,.4);

      $('.vid-switcher').on('click', function(e){

          var el = $(this);
          var vidurl = el.data('vidlink');
          var setimage = el.data('setimg');
          var hash = el.data('hash');
          var newhashlink = '';
          var currenthashlink = $('.sharehash a').attr('href');

          $('.vid-switcher').removeClass('active');

          $('#ls-video>div>iframe').attr('src', vidurl);

          el.find('.go360').fadeIn(300);
          el.find('.back360').fadeOut(300);
          e.preventDefault();

          if(!hash) {
              hash = 'UltraLive';
              newhashlink = "javascript: open_window('https://twitter.com/hashtag/ultralive',1024,720);";
              $('.channel1').addClass('active');
          } else {
              newhashlink = "javascript: open_window('https://twitter.com/hashtag/jointheresistance',1024,720);";
              $('.channel2').addClass('active');
          }

          $('.settimesimage').attr('src',setimage);
          $('.settimeslink').attr('href',setimage);

          $('.sharehash a').text('#'+hash);
          $('.sharehash a, .ste a').attr('href',newhashlink);
          $('.sharehash a, .ste a').attr('title','#'+hash);

      });

      if( !! $("#channel-2-default").length) {
          $('.ls-resistance').trigger('click');
          $('#ls-mobile-switcher .channel2').addClass('active');
      }

      $('.btn360').on('click', function(e){

          var el = $(this);
          var vidurl = el.data('vidlink');
          var backurl = el.data('backlink');

          $('.vid-switcher').removeClass('active');

          if(el.hasClass('active')) {
              el.removeClass('active');
              el.find('.go360').fadeIn(300);
              el.find('.back360').fadeOut(300);
              $('#ls-video>div>iframe').attr('src', backurl);

              log(backurl);
          } else {
              el.addClass('active');
              $('#ls-video>div>iframe').attr('src', vidurl);
              el.find('.go360').fadeOut(300);
              el.find('.back360').fadeIn(300);

              log(vidurl);
          }

          e.preventDefault();

      })


      $('.radiobtn, .radiomobile').on('click', function(){

          var el = $(this);

        //$('.vid-switcher').removeClass('active');
        //el.addClass('active');

    });

  }

}



function livestream2019() {

    if ( ! $('#livestream-2019').length ) {
        return;
    }

    var bg = '<div class="main-bg bg"></div>';
    if ( !! $('div.channels').length && !! $('div.switcher').length  ) {
        //bg += '<div class="overlay-left ch ch2 bg"></div>';
        //bg += '<div class="overlay-right ch ch1 bg"></div>';
    }
    //bg += '<div class="resistance-mobile ch ch2 bg"></div>';
    //bg += '<div class="ulive-mobile ch ch1 bg"></div>';

    $('#background').html(bg);


    $('.switcher li>a').on('click', function(e){
        var el = $(this);
        var channel = el.data('channel');
        e.preventDefault();
        $('.switcher li>a.active').removeClass('active');
        el.addClass('active');
        $(`div.ch${channel}>a`).trigger('click');
    });

    $('div.channels>div>a').on('click', function(e){

        var el = $(this);
        var video = el.data('video');
        var channel = el.data('channel');

        e.preventDefault();

        if ( el.parent().hasClass('active') ) {
            return;
        }

        $('.channel.active').removeClass('active');
        el.parent().addClass('active');

        var videothml = ` <div class="vid-wrap"><iframe width="1280" height="720" src="${video}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>`;

        $('div.vidcover').removeClass('finish1 finish2 finish3');
        // if 3 is active, 2 comes from alt way
        setTimeout(function(){
            $('.lsplayer .video').html(videothml);
        }, 500);

        $('div.vidcover').addClass(`start${channel}`);
        setTimeout(function(){
            $('div.vidcover').addClass(`finish${channel}`);
            $('div.vidcover').removeClass('start'+channel);
        }, 700);

        $('.switcher li a.active').removeClass('active');
        $('#background div.ch:not(.ch'+channel+')').fadeTo(250,.01);
        $('.channel.hidden-channel').removeClass('hidden-channel');
        $('.chnav').removeClass('disabled');

        $(`.switcher li a.ch${channel}`).addClass('active');
        if ( channel == 1 ) {
            $('#background div.ch.ch1').fadeTo(250,.99);
            //$('#livestream-2019 div.chh.ch1').fadeTo(250,.99);
            //$('#livestream-2019 div.chh.ch2').fadeOut(300);
            $('.channel.ch2, .channel.ch3').addClass('hidden-channel');
            $('.chnav.chprev').addClass('disabled');
            $('.ch1 .chstatus span').html('Live');
            $('.ch2 .chstatus span, .ch3 .chstatus span').html('');
        } else if ( channel == 2 ) {
            $('#background div.ch.ch2').fadeTo(250,.99);
            //$('#livestream-2019 div.chh.ch1, #livestream-2019 div.chh.ch3').fadeTo(250,0);
            //$('#livestream-2019 div.chh.ch2').fadeIn(300);
            $('.channel.ch1, .channel.ch3').addClass('hidden-channel');
            $('.chnav.chnext').addClass('disabled');
            $('.ch2 .chstatus span').html('Live');
            $('.ch1 .chstatus span, .ch3 .chstatus span').html('');
        } else {
            $('#background div.ch.ch3').fadeTo(250,.99);
            //$('#livestream-2019 div.chh.ch1, #livestream-2019 div.chh.ch2').fadeTo(250,0);
            //$('#livestream-2019 div.chh.ch3').fadeIn(300);
            $('.channel.ch2, .channel.ch1').addClass('hidden-channel');
            $('.chnav.chnext').addClass('disabled');
            $('.ch3 .chstatus span').html('Live');
            $('.ch1 .chstatus span, .ch2 .chstatus span').html('');
        }

    });

    if ( !! $('div.autoplay1').length ) {

        setTimeout(function() {
            $('.vidlink.ch1').trigger('click');
        }, 500);

    }

    $('.chnav').on('click', function(event) {

        var el = $(this);
        event.preventDefault();

        if ( el.hasClass('disabled') ) {
            return;
        }

        $('.chnav').removeClass('disabled');

        var el = $(this);
        var src = el.data('channel');

        $(`.switcher.desk li:nth-child(${src}) a`).trigger('click');

    });


    //clock();

}

function livestream2022() {
    if ( ! $('#livestream-2022').length ) {
        return;
    }

    let livestreamSettings = $('#livestream-2022').data('livestream-settings');

    $('#background').html('<div class="main-bg bg"></div>');

    function setChannel(channel) {
        let $channel = $(`.channel[data-channel="${channel}"]`);
        let channelSettings = $channel.data('channel-settings');

        if ( $channel.hasClass('active') ) {
            return;
        }

        let currentChannel = $('.channel.active').data('channel');

        let channelDirection = currentChannel > channel;

        let vidcover = $('.vidcover');

        vidcover.show("slide", { direction: channelDirection ? 'left' : 'right' }, 250).promise()
            .then(() => {
                if (channelSettings.enable) {
                    $('.lsplayer .video').html(`<div class="vid-wrap"><iframe width="1280" height="720" src="${channelSettings.video}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>`);
                } else {
                    $('.lsplayer .video').html(`<div class="vid-wrap"><img src="${channelSettings.placeholder}" alt="${channelSettings.title}" class="block"></div>`);
                }

                $('.channel.active').removeClass('active');
                $channel.addClass('active');

                $('.switcher li a.active').removeClass('active');
                $(`.switcher li a[data-channel="${channel}"]`).addClass('active');

                $('.chstatus span').html('');
                $channel.find('.chstatus span').html('Live');
            })
            .then(() => vidcover.hide("slide", {direction: channelDirection ? 'right' : 'left'}, 250));
    }

    $('.switcher li > a, div.channels > div > a').on('click', function(e){
        e.preventDefault();

        let channel = $(this).data('channel');
        if ( channel ) {
            setChannel(channel);
        }
    });

    let currentTimeInterval = null;
    function setTime() {
        let timezone = $('#use-local-timezone').prop("checked") ? moment.tz.guess() : livestreamSettings.timezone;

        $('.channel ul li').each(function() {
            let startTime = moment.tz($(this).data('start-time'), timezone);
            let endTime = moment.tz($(this).data('end-time'), timezone);
            $(this).find('.set-time').html(startTime.locale(navigator.language).format('LT'));
        });

        let updateCurrentTime = function () {
            let currentTime = moment().tz(timezone);
            $('#current-time').html(currentTime.locale(navigator.language).format('LT z'));

            $('.channel ul li').each(function() {
                let startTime = moment.tz($(this).data('start-time'), timezone);
                let endTime = moment.tz($(this).data('end-time'), timezone);

                if (currentTime.isBetween(startTime, endTime)) {
                    $(this).addClass('live');
                } else {
                    $(this).removeClass('live');
                }
            });
        }

        clearInterval(currentTimeInterval);
        currentTimeInterval = setInterval(updateCurrentTime, 1000);
        updateCurrentTime();
    }

    $('#use-local-timezone')
        .on('change', function() {
            setTime()
        });

    setTime();

    if ( livestreamSettings.autoplay ) {
        let channel = $('.channels .channel[data-channel-enabled="true"]:first').data('channel');
        if ( channel ) {
            setChannel(channel);
        }
    }
}
